@if (isVisible) {
  <div class="tooltip">
    <ng-content></ng-content>
  </div>
}
